import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h4`
  margin: 0;
`;

export const ActionButton = styled.button`
  background-color: black;
  color: white;
  padding: 0.5rem 1rem;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background-color: #333;
  }
`;

export const Message = styled.p`
  margin-top: 1rem;
  font-style: italic;
`;